export const enum ClickToPayAdapterName {
  HPP = "hpp",
}
